// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"0a87fa6b","507":"d10750b8","724":"7260f675","847":"f637b75d","928":"1468a617"}[chunkId] + ".chunk.css";
};